import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Box } from 'rebass'

const DefinitionList = styled(Box)`
    dt {
        display: none;
    }
    dd {
        border-color: ${(props) => props.theme.colors.black};
        border-style: solid;
        border-width: 1px 0 0 0;
        margin-left: 0;
        padding-bottom: ${(props) => props.theme.space.sm};
        padding-top: ${(props) => props.theme.space.sm};
        &:last-child {
            border-width: 1px 0;
        }
        &.chassis::before {
            content: "Chassis no. ";
        }
        &.engine::before {
            content: "Engine no. ";
        }
        &.price::before {
            content: "Price ";
        }
  }
`

const VehicleDetails = ({ chassis, engine, category }) => {
    const theme = useContext(ThemeContext)

    const inspectChassis = () => {
        if (chassis && chassis.number && chassis.number !== '' && chassis.visible) {
            return <><dt>Chassis no.</dt>
                <dd className="chassis">{chassis.number}</dd></>
        }
    }
    const inspectEngine = () => {
        if (engine && engine.number && engine.number !== '' && engine.visible) {
            return <><dt>Engine no.</dt>
                <dd className="engine">{engine.number}</dd></>
        }
    }

    const inspectCategory = () => {
        if (category && category !== '') {
            // TODO: revisit the category value and comparison operator; it smells iffy and prone to breakage
            const term = (category === 'recently-sold' || category === 'sold') ? '' : 'Price'
            const description = (category === 'recently-sold' || category === 'sold') ? 'Previously handled' : 'on request'
            const className = (category === 'recently-sold' || category === 'sold') ? 'default' : 'price'

            return <><dt>{term}</dt>
                <dd className={className}>{description}</dd></>
        }
    }
    return (
        <DefinitionList
            as="dl"
            marginBottom="md"
            theme={theme}
        >
            {inspectChassis()}
            {inspectEngine()}
            {inspectCategory()}
        </DefinitionList>
    )
}

export default VehicleDetails
